import { render, staticRenderFns } from "./ProjectPageSpeedDial.vue?vue&type=template&id=7e63039e&scoped=true&"
import script from "./ProjectPageSpeedDial.vue?vue&type=script&lang=js&"
export * from "./ProjectPageSpeedDial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e63039e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBadge,VBtn,VIcon,VScaleTransition})
